import React, { useState, useEffect } from "react";
import { Input, Spin } from "antd";
import { api, endpoint } from "../../api";
import moment from "moment";
import { DataTable } from "../../components";
import PropTypes from "prop-types";
import { flare } from "@flareapp/js";

const DeviceListOnDeviceForm = ({ site, business, devices, onSelectDevice }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [deviceList, setDeviceList] = useState([]);
  const [deviceLoading, setDeviceLoading] = useState(false);

  const getDevices = async () => {
    setDeviceLoading(true);
    try {
      const response = await api.get(endpoint.get_devices, {
        params: {
          limit,
          page,
          sortBy: "createdAt",
          orderBy: "DESC",
          searchText: searchTerm,
          business,
          site,
          // status: searchByStatus,
        },
      });
      setDeviceList(response?.results);
      setTotal(response?.count);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setDeviceLoading(false);
  };

  useEffect(() => {
    getDevices();
  }, [limit, searchTerm, page, business]);
  const columns = [
    {
      title: "No.",
      render: (_, __, index) => <div>{(page - 1) * limit + index + 1}</div>,
      maxWidth: "60px",
      align: "center",
    },
    {
      title: "Device Name",
      render: (_, row) => row?.name,
    },
    {
      title: "Device Type",
      render: (_, row) => row?.deviceType?.name || "",
    },
    {
      title: "Site Name",
      render: (_, row) => row?.site?.name || "",
    },
    {
      title: "Date Installed",
      render: (_, row) => moment(row.createdAt).format("DD/MM/YYYY"),
      center: true,
    },
    {
      title: "Action",
      render: (_, row) => (
        <div className="actions ">
          <input
            // className="form-check-input border border-success "
            type="checkbox"
            value={row._id}
            id="flexCheckDefault"
            onChange={onSelectDevice}
            checked={devices?.includes(row._id)}
          />
        </div>
      ),
      align: "center",
    },
  ];

  return (
    <Spin spinning={deviceLoading}>
      <div className="row mb-2 mt-4">
        <div className="col-md-10">
          <h6 className="py-2">Assign Multiple Devices to Virtual Device</h6>
        </div>
        <div className="col-md-2">
          <Input
            type="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search"
            size="large"
          />
        </div>
      </div>
      <DataTable
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={deviceList}
        pagination={{
          pageSize: limit,
          current: page,
          total,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          pageSizeOptions: [10, 20, 50],
          responsive: true,
        }}
        onChange={(pagination) => {
          setPage(pagination.current);
          setLimit(pagination.pageSize);
        }}
      />
    </Spin>
  );
};

export default DeviceListOnDeviceForm;

DeviceListOnDeviceForm.propTypes = {
  site: PropTypes.object.isRequired,
  business: PropTypes.object.isRequired,
  devices: PropTypes.array.isRequired,
  onSelectDevice: PropTypes.func.isRequired,
};
